import { Actions } from './actions';
import moment from 'moment';

export default (state = {}, action) => {
    switch (action.type) {
        case Actions.FOUND_AVAILABILITY: {
            // Using parseZone keeps the time zone specified in the availability string
            const date = moment.parseZone(action.payload.availability);

            const defaultDT = () => {
                return 'MMM Do [at] h:mm a';
            };

            const friendlyTime = date.calendar(null, {
                sameDay: '[today at] h:mm a',
                nextDay: '[tomorrow at] h:mm a',
                nextWeek: defaultDT,
                lastDay: defaultDT,
                lastWeek: defaultDT,
                sameElse: defaultDT,
            });

            return {
                ...state,
                nextAvailability: friendlyTime,
            };
        }
        case Actions.START_SEARCH_NEXT_AVAILABILITY: return {
            ...state,
            nextAvailability: undefined,
        };
        default:
            return state;
    }
};
